import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6401725c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "primary-container" }
const _hoisted_2 = { class: "shadow-lg p-6 bg-white rounded-2xl mx-auto" }
const _hoisted_3 = { class: "text-dark-grey font-medium text-2xl mb-6" }
const _hoisted_4 = { class: "text-sm mb-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "w-full mt-4 flex items-center gap-x-4" }
const _hoisted_7 = {
  key: 0,
  class: "fontbottom-1/2 left-1/2 -translate-x-1/2 translate-y-1/2"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "form-card-tabs-container-wonde"
}
const _hoisted_10 = { class: "columns-2 mt-4" }
const _hoisted_11 = { class: "columns-2 mt-4" }
const _hoisted_12 = { class: "columns-2 mt-4" }
const _hoisted_13 = { class: "columns-2 mt-4" }
const _hoisted_14 = { class: "columns-2 mt-4" }
const _hoisted_15 = { class: "columns-2 mt-4" }
const _hoisted_16 = { class: "columns-1 mt-4" }
const _hoisted_17 = { class: "columns-1 mt-4" }
const _hoisted_18 = { class: "m-0 pt-4 pb-4" }
const _hoisted_19 = { class: "text-base font-semibold mb-4" }
const _hoisted_20 = {
  key: 0,
  class: "fontbottom-1/2 left-1/2 -translate-x-1/2 translate-y-1/2"
}
const _hoisted_21 = { class: "text-gray-700 text-md font-semibold border border-gray-300 px-3 py-2 bg-white rounded-lg" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-base font-semibold mb-4 mt-4" }, "All Classes")
], -1))
const _hoisted_23 = { class: "text-gray-700 text-md font-semibold border border-gray-300 px-3 py-2 bg-white rounded-lg" }
const _hoisted_24 = { class: "text-base font-semibold mb-4 mt-3" }
const _hoisted_25 = {
  key: 0,
  class: "fontbottom-1/2 left-1/2 -translate-x-1/2 translate-y-1/2"
}
const _hoisted_26 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2" }
const _hoisted_27 = { class: "flex-shrink-0" }
const _hoisted_28 = { class: "text-indigo text-blue-600 [&>svg]:stroke-current [&>svg]:h-8 [&>svg]:w-8" }
const _hoisted_29 = { class: "min-w-0 flex-1" }
const _hoisted_30 = { class: "focus:outline-none" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "absolute inset-0",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_32 = { class: "text-sm font-medium text-gray-900 text-blue-600 leading-6" }
const _hoisted_33 = { class: "text-gray-900 text-xs leading-6" }
const _hoisted_34 = {
  key: 0,
  class: "truncate text-sm text-gray-500 leading-6"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 1,
  class: "truncate text-sm text-gray-500 leading-6"
}
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "flex justify-between mt-4" }
const _hoisted_39 = { class: "h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 me-0" }
const _hoisted_40 = { class: "w-full max-w-xl p-8 text-center" }
const _hoisted_41 = { class: "text-lg font-medium leading-6" }
const _hoisted_42 = { class: "mt-2" }
const _hoisted_43 = { class: "text-sm text-gray-500" }
const _hoisted_44 = { class: "mt-4" }

import { ref, watch, computed, onBeforeMount } from "vue";
import { useSchoolGroupStore } from "@/stores/schoolGroupsStore";
import { useWondeApiStore } from "@/stores/wondeStore";
import { useProductStore } from '@/stores/productStore';
import { useSubjectStore } from '@/stores/subjectStore';
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import { School } from "@/interfaces/school.interface";
import i18n from "@/plugins/i18n";
import { wondeDefaultSchoolObject } from "@/modules/main/components/constants/defaults";

//store
import type { ClassGroup } from "@/interfaces/class-group.interface";
import { NewClassGroup, SchoolStructureClassGroup } from "@/interfaces/school-structure.interface";
interface SelectOption {
  label: string;
  value: string;
  attrs?: { [key: string]: any };
}

// Fetch school groups on component mount

export default /*#__PURE__*/_defineComponent({
  __name: 'InternalWondeImportView',
  setup(__props) {

const schoolGroupsStore = useSchoolGroupStore();
const wondeStore = useWondeApiStore();
const subjectStore = useSubjectStore();
const productStore = useProductStore();
//refs
const loading = ref(false);
const loadingStructure = ref(false);
const selectedSchool = ref<any>(null);
const schoolGroupOptions = ref<string>("") as any;
let allWondeSchools = ref<{ data: any[] } | null>(null);
let existingSchools = ref([]);
const wondeSchoolOptions = ref<SelectOption[]>([]);
const selectedWondeSchoolId = ref<string>("");
const wondeSchoolClasses = ref<ClassGroup[]>([]) as any;
const wondeSchoolTeachers = ref([]);
const responseModalVisible = ref(false);
const responseModal = ref({
  title: i18n.global.t("students_view.no_assigned_classes"),
  description: i18n.global.t("internal_view.wonde.school_created_success"),
  buttonText: "Okay",
});

const schoolObject =  ref(wondeDefaultSchoolObject) as unknown as School as any;

onBeforeMount(async () => {
  loading.value = true;
  allWondeSchools.value = await wondeStore.getSchools() as any;
  existingSchools.value = await wondeStore.getExistingSchools() as any;
  wondeSchoolOptions.value = allWondeSchools.value?.data?.map((school: any) => {
    // Allow selecting existing schools (remove disabled flag)
    return {
      label: school.name,
      value: school.id,
    } as SelectOption;
  }) || [];
  loading.value = false;
});

/**
 * Selected School show details and populate fields
 */
watch(
  selectedWondeSchoolId,
  async (newVal) => {
    if (newVal) {
      selectedSchool.value = allWondeSchools.value && allWondeSchools.value.data
        ? allWondeSchools.value.data.find((school) => school.id === newVal)
        : null;

      // If it's an existing Wonde-enabled school, do not populate form
      if (isExistingWondeSchool.value) {
        schoolObject.value = { ...wondeDefaultSchoolObject } as any;
        return;
      }

      if (selectedSchool.value) {
        schoolObject.value = {
          wondeId: selectedSchool.value.id,
          wondeApi: selectedSchool.value.region.domain,
          name: selectedSchool.value.name,
          description: `PHASE: ${selectedSchool.value.phase_of_education}. CODE: ${selectedSchool.value.la_code}. URN: ${selectedSchool.value.urn}. MIS: ${selectedSchool.value.mis}. Establishment Number: ${selectedSchool.value.establishment_number}`,
          location: {
            city: selectedSchool.value.address.address_town,
            country: selectedSchool.value.address.address_country.name,
          }
        } as any;
        console.log("Selected School Object:", schoolObject.value);
      }
    }
  },
  {
    deep: true,
  }
);
/**
 * Populate Classes, Teachers & Students Tabs when school is selected
 */
watch(
  selectedWondeSchoolId,
  async (newVal) => {
    if (!newVal) return;

    // If existing school, skip all fetches and clear structure state
    if (isExistingWondeSchool.value) {
      wondeSchoolClasses.value = [];
      wondeSchoolTeachers.value = [];
      schoolGroupOptions.value = [];
      loadingStructure.value = false;
      return;
    }

    const currentSchool = allWondeSchools.value && allWondeSchools.value.data
      ? allWondeSchools.value.data.find((school) => school.id === newVal)
      : null;

    loadingStructure.value = true;
    try {
      const [schoolEntities, schoolGroups] = await Promise.all([
        currentSchool ? wondeStore.getSchoolEntities(currentSchool.id) : Promise.resolve({ classGroups: [], teachers: [] }),
        schoolGroupsStore.fetchSchoolGroups(),
      ]);
      wondeSchoolClasses.value = schoolEntities.classGroups;
      wondeSchoolTeachers.value = schoolEntities.teachers;

      const schoolGroupEntries = schoolGroupsStore.getSchoolGroups;
      schoolGroupOptions.value = schoolGroupEntries.map((group) => ({
        label: group.name,
        value: group._id,
      }));

      const uniqueGrades = new Set<number>();
      wondeSchoolClasses.value.forEach((classGroup: any) => uniqueGrades.add(classGroup.grade));
      const sortedGrades = Array.from(uniqueGrades).sort((a, b) => a - b);
      if (sortedGrades) schoolObject.value.gradeLevels = sortedGrades.join(",");
    } catch (error: any) {
      showResponseModal("Error", error.message, "Okay");
    }
    loadingStructure.value = false;
  },
  {
    deep: true,
  }
);

/**
 * Convert the date to MM-DD format required by model
 * @param dateString
 * @returns string
 */
const formatDateToMMYY = (dateString: string): string => {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${month}-${day}`;
};

/**
 * Extract domain name from URL if necessary
 */
const extractDomainName = (url: string): string => {
  const domainPattern = /^(?:https?:\/\/)?(?:www\.)?([^/]+)/i;
  const match = url.match(domainPattern);
  return match ? match[1] : "";
};

/**
 * Save and Sync School
 */
const saveAndSync = async () => {
  if (schoolObject.value) {
    schoolObject.value.gradeLevels = (schoolObject.value.gradeLevels) ? 
      schoolObject.value.gradeLevels?.split(",")
      .map((grade: any) => parseInt(grade)) : [];
    schoolObject.value.academicYearStart = formatDateToMMYY(
      schoolObject.value.academicYearStart
    );
    schoolObject.value.academicYearEnd = formatDateToMMYY(
      schoolObject.value.academicYearEnd
    );
    schoolObject.value.wondeApi = extractDomainName(
      schoolObject.value.wondeApi
    );
    const savedSchool = await wondeStore
      .createSchool(schoolObject.value)
      .then(function (response) {
        if (response.success === true) {
          wondeStore.triggerJobSync(response.data.wondeId);
          showResponseModal(
            "Success!",
            "School created and the sync operations have begun. Check back later to see the results.",
            "OK"
          );
        } else {
          showResponseModal(
            "Error",
            "There was a problem with the request.",
            "Okay"
          );
        }
      })
      .catch(function (error) {
        showResponseModal("Error", error.message, "Okay");
      });
  } else {
    showResponseModal(
      "Error",
      "There was a problem with the school data, refresh and try again.",
      "Okay"
    );
  }
};

const mathsId = computed(() => {
  const s = (subjectStore.getSubjects || subjectStore.subjects || []).find(
    (x: any) => x.name?.toLowerCase() === "maths"
  );
  return s?.id ?? s?._id ?? "";
});

const englishId = computed(() => {
  const s = (subjectStore.getSubjects || subjectStore.subjects || []).find(
    (x: any) => x.name?.toLowerCase() === "english"
  );
  return s?.id ?? s?._id ?? "";
});
const subjectOptions = computed(() => {
  const subjects = subjectStore.getSubjects || subjectStore.subjects || [];
  const options = (subjects as any[]).map((s: any) => ({
    label: s.name,
    value: s.id ?? s._id,
  }));

  if (mathsId.value && englishId.value) {
    return [
      { label: "Maths and English", value: [mathsId.value, englishId.value] },
      ...options,
    ];
  }

  return options;
});

// Replace the earlier watch normalizer with this computed proxy:
const selectedSubjects = computed({
  get() {
    const val = schoolObject.value?.subjectsAvailable;
    if (!val) return "";
    if (Array.isArray(val)) {
      // both selected
      if (val.includes(mathsId.value) && val.includes(englishId.value)) return "both";
      // single selection -> return first id (FormKit single-select expects a scalar)
      return val[0] ?? "";
    }
    // fallback
    return String(val);
  },
  set(v: string | string[]) {
    if (v === undefined || v === null) {
      schoolObject.value.subjectsAvailable = [];
      return;
    }
    if (Array.isArray(v)) {
      schoolObject.value.subjectsAvailable = v;
      return;
    }
    if (v === "both") {
      schoolObject.value.subjectsAvailable = [mathsId.value, englishId.value].filter(Boolean);
      return;
    }
    // single id
    schoolObject.value.subjectsAvailable = [v];
  },
});

/**
 * Toggle Modal visibility and set the content
 */
const closeResponseModal = async () => {
  responseModalVisible.value = false;
};
const showResponseModal = async (
  title?: string,
  description?: string,
  btnText?: string
) => {
  responseModal.value = {
    title: title ? title : responseModal.value.title,
    description: description ? description : responseModal.value.description,
    buttonText: btnText ? btnText : responseModal.value.buttonText,
  };
  responseModalVisible.value = true;
};

/**
 * Only show teachers within the selected classes
 */
const filterTeachersByClasses = () => {
  const classIds = new Set(
    wondeSchoolClasses.value.map((schoolClass: any) => schoolClass.id)
  );
  const filteredTeachers = wondeSchoolTeachers.value.filter((teacher: any) => {
    const hasValidClass = teacher.classes.data.some((cls: any) =>
      classIds.has(cls.id)
    );
    const hasValidGroup = teacher.groups.data.some((grp: any) =>
      classIds.has(grp.id)
    );
    return hasValidClass || hasValidGroup;
  });

  wondeSchoolTeachers.value = filteredTeachers;
  return;
};

/**
 * Computed Properties for ClassGroups
 */
const mathsClasses = computed(() => {
  return wondeSchoolClasses.value;
});
const allGrades = computed(() => {
  const grades = wondeSchoolClasses.value.map((group: any) => group.grade);
  const uniqueGrades = [...new Set(grades)];
  return uniqueGrades.sort((a: any, b: any) => b - a);
});

// Determine if the currently selected wonde school is already imported/enabled
const isExistingWondeSchool = computed(() => {
  const id = selectedWondeSchoolId.value;
  if (!id || !Array.isArray(existingSchools.value)) return false;
  return existingSchools.value.some((s: any) => s.wondeId === id);
});

// Trigger sync for an existing Wonde-enabled school
const syncExistingSchoolNow = async () => {
  if (!selectedWondeSchoolId.value) {
    showResponseModal("Error", "Please select a Wonde school first.", "Okay");
    return;
  }
  try {
    await wondeStore.triggerJobSync(selectedWondeSchoolId.value);
    showResponseModal(
      "Success!",
      "School sync is in progress. All changes should be actioned within 24 hours.",
      "OK"
    );
  } catch (error: any) {
    showResponseModal("Error", error?.message || "Failed to trigger sync jobs.", "Okay");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("internal_view.wonde.header")), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("internal_view.wonde.description")), 1),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_FormKit, {
            type: "select",
            label: "Wonde Schools",
            placeholder: "Select a School",
            name: "school",
            modelValue: selectedWondeSchoolId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedWondeSchoolId).value = $event)),
            options: wondeSchoolOptions.value,
            classes: {
            outer: 'w-1/2',
          },
            disabled: loading.value
          }, null, 8, ["modelValue", "options", "disabled"]),
          (loading.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _createVNode(_component_spinner_loader, { color: 'text-blue-600 dark:text-blue-600' })
              ]))
            : _createCommentVNode("", true),
          (isExistingWondeSchool.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "sync-btn bg-indigo-600 rounded-lg px-4 py-0 text-white shadow",
                onClick: syncExistingSchoolNow,
                disabled: loadingStructure.value
              }, " Sync School Now ", 8, _hoisted_8))
            : _createCommentVNode("", true)
        ])
      ]),
      (selectedSchool.value && !isExistingWondeSchool.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_unref(TabView), { class: "mt-9" }, {
              default: _withCtx(() => [
                _createVNode(_unref(TabPanel), { header: "School details" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FormKit, {
                      type: "form",
                      id: "login-form",
                      actions: false,
                      onSubmit: saveAndSync
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_FormKit, {
                            disabled: "",
                            type: "text",
                            label: "Wonde ID",
                            placeholder: "Wonde ID",
                            modelValue: schoolObject.value.wondeId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((schoolObject.value.wondeId) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "select",
                            label: "School Group",
                            placeholder: "Select Group",
                            name: "group",
                            modelValue: schoolObject.value.schoolGroup,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((schoolObject.value.schoolGroup) = $event)),
                            options: schoolGroupOptions.value,
                            validation: "required",
                            "validation-messages": {
                  required: 'A School Group is required.',
                }
                          }, null, 8, ["modelValue", "options", "validation-messages"])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_FormKit, {
                            type: "text",
                            label: "City",
                            placeholder: "City name",
                            modelValue: schoolObject.value.location.city,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((schoolObject.value.location.city) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "text",
                            label: "Country",
                            placeholder: "Country name",
                            modelValue: schoolObject.value.location.country,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((schoolObject.value.location.country) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_FormKit, {
                            type: "select",
                            label: "Grade naming convention",
                            placeholder: "Grade naming convention",
                            modelValue: schoolObject.value.gradeNamingConvention,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((schoolObject.value.gradeNamingConvention) = $event)),
                            options: {
                  grade: 'Grade',
                  year: 'Year',
                  level: 'Level',
                },
                            validation: "required",
                            "validation-messages": {
                  required: 'Grade naming convention is required.',
                }
                          }, null, 8, ["modelValue", "validation-messages"]),
                          _createVNode(_component_FormKit, {
                            type: "text",
                            label: "Grade Levels",
                            placeholder: "Grade levels (comma separated)",
                            modelValue: schoolObject.value.gradeLevels,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((schoolObject.value.gradeLevels) = $event)),
                            validation: "required",
                            "validation-messages": {
                  required:
                    'Grade levels are required and should be comma separated.',
                }
                          }, null, 8, ["modelValue", "validation-messages"])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_FormKit, {
                            type: "select",
                            options: {
                'en-ZA': 'English - South Africa',
                'af-ZA': 'Afrikaans - South Africa',
                'en-AU': 'English - Australia',
                'en-UK': 'English - United Kingdom',
                'en-GB': 'English - Great Britain',
                'en-ND': 'English - ND',
              },
                            label: "Assessment Language",
                            validation: "required",
                            placeholder: "Select Assessment Language",
                            modelValue: schoolObject.value.preferredLang,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((schoolObject.value.preferredLang) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "select",
                            name: "subjects",
                            options: subjectOptions.value,
                            label: _ctx.$t('internal_tools.form.subject'),
                            placeholder: _ctx.$t('internal_tools.form.select_subject'),
                            style: { color: 'text-gray-500', height: '3.5rem' },
                            modelValue: selectedSubjects.value,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedSubjects).value = $event)),
                            validation: "required"
                          }, null, 8, ["options", "label", "placeholder", "modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_FormKit, {
                            type: "date",
                            label: "General date of academic year start",
                            modelValue: schoolObject.value.academicYearStart,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((schoolObject.value.academicYearStart) = $event)),
                            validation: "required",
                            "validation-messages": {
                  required: 'Academic Year Start is required.',
                }
                          }, null, 8, ["modelValue", "validation-messages"]),
                          _createVNode(_component_FormKit, {
                            type: "date",
                            label: "General date of academic year end",
                            modelValue: schoolObject.value.academicYearEnd,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((schoolObject.value.academicYearEnd) = $event)),
                            validation: "required",
                            "validation-messages": {
                  required: 'Academic Year End is required.',
                }
                          }, null, 8, ["modelValue", "validation-messages"])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_FormKit, {
                            type: "text",
                            label: "EMIS number",
                            placeholder: "EMIS number",
                            modelValue: schoolObject.value.emisNumber,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((schoolObject.value.emisNumber) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "text",
                            label: "Domain name",
                            placeholder: "schoolname.com",
                            modelValue: schoolObject.value.domain,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((schoolObject.value.domain) = $event)),
                            validation: [
                  ['required'],
                  [
                    'matches',
                    /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
                  ],
                ],
                            "validation-messages": {
                  required:
                    'Domain name is required. Students without email addresses will be created using this domain.',
                  matches:
                    'Domain name needs to be in a format like schoolname.com or school.area.sch.uk',
                }
                          }, null, 8, ["modelValue", "validation", "validation-messages"])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_FormKit, {
                            type: "text",
                            name: "description",
                            label: "Description",
                            placeholder: "General description of the school.",
                            class: "primary-select",
                            modelValue: schoolObject.value.description,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((schoolObject.value.description) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "hidden",
                            name: "wondeApi",
                            modelValue: schoolObject.value.wondeApi,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((schoolObject.value.wondeApi) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_FormKit, {
                            type: "submit",
                            class: "mb-1 mt-9 inline-block w-full bg-indigo-400 shadow-[0px 4px 10px 0px] shadow-md text-base font-medium leading-normal text-white mt-8",
                            inputClass: "mt-6 px-6 py-[10px]"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("internal_view.wonde.btn_create_and_sync")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(TabPanel), { header: "Grades & Classes" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("h2", _hoisted_19, [
                            _createTextVNode(_toDisplayString(_ctx.$t("internal_view.wonde.all_classgroups")) + " ", 1),
                            (loadingStructure.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                  _createVNode(_component_spinner_loader, { color: 'text-blue-600 dark:text-blue-600 w-4 h-4' })
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allGrades.value, (grade) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "inline-flex mr-1 ml-2 mb-2",
                            key: (grade as number)
                          }, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(grade), 1)
                          ]))
                        }), 128)),
                        _hoisted_22,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mathsClasses.value, (group) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "inline-flex mr-1 ml-2 mb-2",
                            key: group.gradeClass
                          }, [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(group.name), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(TabPanel), { header: "Teacher details" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_24, [
                      _createTextVNode(_toDisplayString(_ctx.$t("internal_view.wonde.all_teachers")) + " ", 1),
                      (loadingStructure.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                            _createVNode(_component_spinner_loader, { color: 'text-blue-600 dark:text-blue-600 w-4 h-4' })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((wondeSchoolTeachers.value as any), (teacher) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "relative flex items-center text-black space-x-3 rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400",
                          key: teacher.id
                        }, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("span", _hoisted_28, [
                              _createVNode(_component_rl_icon, {
                                icon: 'rl-profile',
                                title: 'rl profile',
                                "aria-hidden": "true"
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("a", _hoisted_30, [
                              _hoisted_31,
                              _createElementVNode("p", _hoisted_32, _toDisplayString(teacher.title) + " " + _toDisplayString(teacher.forename) + " " + _toDisplayString(teacher.surname), 1),
                              _createElementVNode("p", _hoisted_33, _toDisplayString(teacher.contact_details?.data?.emails.email), 1),
                              (teacher.classes.data.length > 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                                    _createTextVNode(" Classes: "),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teacher.classes.data, (classItem, index) => {
                                      return (_openBlock(), _createElementBlock("span", { key: index }, [
                                        _createTextVNode(_toDisplayString(classItem.name), 1),
                                        (index < teacher.classes.data.length - 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, ", "))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              (teacher.groups.data.length > 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_36, [
                                    _createTextVNode(" Groups: "),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teacher.groups.data, (groupItem, index) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: index,
                                        class: "font-semibold"
                                      }, [
                                        _createTextVNode(_toDisplayString(groupItem.name), 1),
                                        (index < teacher.groups.data.length - 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, ", "))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_38, [
        _createVNode(_component_router_link, {
          to: "/main/internal",
          class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_39, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-small-back-arrow',
                title: 'rl small back arrow',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('internal_tools.school_group.btn_back')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-xl',
      open: responseModalVisible.value,
      onLocalModalOpen: _cache[15] || (_cache[15] = ($event: any) => (responseModalVisible.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("h3", _hoisted_41, _toDisplayString(responseModal.value.title), 1),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("p", _hoisted_43, _toDisplayString(responseModal.value.description), 1)
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("button", {
              type: "button",
              class: "w-full bg-blue-600 rounded-lg p-2.5 text-base shadow-lg text-white flex flex-row justify-center items-center flex-wrap",
              onClick: closeResponseModal
            }, _toDisplayString(responseModal.value.buttonText), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})